import { triggerHostMessageCloseThirdPartyDemoExitConfirmation } from '../triggerHostMessage/triggerHostMessageCloseThirdPartyDemoExitConfirmation';
export default function closeThirdPartyDemoExitConfirmationHandler(data) {
  triggerHostMessageCloseThirdPartyDemoExitConfirmation(data);
}